<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <TextBox
          v-model="value.parameter1"
          :config="{ title: 'Variable Name', isRequired: true }"
        />
      </v-col>
      <v-col cols="12">
        <ServerCalculationEditor title="Value" v-model="value.parameter2" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TextBox from "../../ui/controls/TextBox.vue";
import ServerCalculationEditor from "../../ui/shared/ServerCalculationEditor.vue";

export default {
  name: "SetVariableDesigner",

  components: { TextBox, ServerCalculationEditor },

  props: ["value"],
};
</script>